import { useSearchParams } from "react-router-dom"
import camelCase from "lodash/camelCase"

/**
 * Return normalized parameter from URL
 *
 * @remarks
 * For now, normalized means
 * 1. camelCase the key
 *
 * @returns Object with camelCased key
 *
 */
export const useNormalizedRouterSearchParams = <
  T extends Record<string, string>
>(): T => {
  const [searchParams] = useSearchParams()
  const normalizedParams = {}
  for (const entry of searchParams.entries()) {
    const [paramKey, value] = entry
    normalizedParams[camelCase(paramKey)] = value
  }
  return normalizedParams as T
}
